module.exports = __webpack_public_path__ + "img/chinesecompany92.338424c0.png";